
export const getNftLelveByTokenId = (val) => {
    // 1: 1-9000
    // 2: 9001-9900
    // 3: 9901-9990
    // 4: 9991-10000
    const tokenId = +val

    if (1<= tokenId && tokenId <=9000) {
        return 1
    }

    if (9001<= tokenId && tokenId <=9900) {
        return 2
    }

    if (9901<= tokenId && tokenId <=9990) {
        return 3
    }

    if (9991<= tokenId && tokenId <=10000) {
        return 4
    }

    return 0
};